import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class AutocompleteService {
    _baseUrl: string;

    constructor(private _httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._baseUrl = baseUrl;
    }

    getFust(id: number): Observable<IFust> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getfust';

        let param: any;
        param = {
            'id': id
        };

        return this._httpClient.get<IFust>(requestUrl, { params: param });
    }

    getFusten(searchTerm: string, getAll: boolean = false): Observable<IFust[]> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getfusten';

        let param: any;
        param = {
            'searchterm': searchTerm,
            'getAll': getAll
        };

        return this._httpClient.get<IFust[]>(requestUrl, { params: param });
    }

    getDooshoogtes(searchTerm: string): Observable<number[]> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getdooshoogtes';

        let param: any;
        param = {
            'searchterm': searchTerm,
        };

        return this._httpClient.get<number[]>(requestUrl, { params: param });
    }

    getPotmaten(searchTerm: string, selectedEan?: number): Observable<number[]> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getpotmaten';

        let param: any;
        param = {
            'searchterm': searchTerm,
        };

        if (selectedEan) {
            param['forKwekerEan'] = selectedEan;
        }

        return this._httpClient.get<number[]>(requestUrl, { params: param });
    }

    getKwekerArtikelNrs(searchTerm: string, selectedEan?: number): Observable<string[]> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getkwekerartikelnrs';

        let param: any;
        param = {
            'searchterm': searchTerm,
        };

        if (selectedEan) {
            param['forKwekerEan'] = selectedEan;
        }

        return this._httpClient.get<string[]>(requestUrl, { params: param });
    }

    getAfmetingStickers(searchTerm: string, selectedEan?: number): Observable<string[]> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getafmetingstickers';

        let param: any;
        param = {
            'searchterm': searchTerm,
        };

        if (selectedEan) {
            param['forKwekerEan'] = selectedEan;
        }

        return this._httpClient.get<string[]>(requestUrl, { params: param });
    }

    getVbnFeatureTypes(searchTerm?: string): Observable<IVbnFeatureType[]> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getvbnfeaturetypes';

        let param: any;
        param = {};
        if (searchTerm) param.searchterm = searchTerm;

        return this._httpClient.get<IVbnFeatureType[]>(requestUrl, { params: param });
    }

    getVbnFeatureValues(type: string, searchTerm?: string): Observable<IVbnFeatureValue[]> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getvbnfeaturevalues';

        let param: any;
        param = {
            'type': type,
            'getall': true
        };
        if (searchTerm) param.searchterm = searchTerm;

        return this._httpClient.get<IVbnFeatureValue[]>(requestUrl, { params: param });
    }

    getSupplierAssignedIDs(searchTerm?: string, kwekerEan?: number): Observable<DataResult<ISelectItem>> {
        const requestUrl = this._baseUrl + 'api/autocomplete/getSupplierAssignedIDs';

        let param: any;
        param = {
            //'getall': true
        };
        if (searchTerm) param.searchterm = searchTerm;
        if (kwekerEan) param.kwekerEan = kwekerEan;

        return this._httpClient.get<DataResult<ISelectItem>>(requestUrl, { params: param });
    }
}

export interface DataResult<T> {
    code: number;
    data: T[];
    message: string
}
export interface ISelectItem {
    id: number;
    text: string;
}

export class Fust implements IFust {
    id: number;
    alfa: string;
    naam: string;
}

export interface IFust {
    id: number;
    alfa: string;
    naam: string;
}

export class VbnFeatureType implements IVbnFeatureType {
    id: string;
    description: string;
    label: string;
}

export class VbnFeatureValue implements IVbnFeatureValue {
    id: number;
    featureTypeId: string;
    featureValue: string;
    description: string;
    label: string;
}

export interface IVbnFeatureValue {
    id: number;
    featureTypeId: string;
    featureValue: string;
    description: string;
    label: string;
}

export interface IVbnFeatureType {
    id: string;
    description: string;
    label: string;
}